import React from 'react';

/**
 * Section card with header — reference dashboard panel style.
 */
export default function Section({
  title,
  eyebrow,
  description,
  action,
  children,
  padding = 'default',
  variant = 'default',
  className = '',
}) {
  const pad =
    padding === 'none'   ? 'p-0' :
    padding === 'tight'  ? 'p-4' :
    padding === 'loose'  ? 'p-8' :
                           'p-6';

  const surface = variant === 'flat' ? '' : 'app-surface';

  return (
    <section className={`app-contained ${surface} ${pad} min-w-0 max-w-full overflow-hidden ${className}`.trim()}>
      {(title || eyebrow || action || description) && (
        <header className={`${pad === 'p-0' ? 'px-6 pt-6 pb-4' : 'pb-5'} flex flex-wrap items-start justify-between gap-4 min-w-0`}>
          <div className="min-w-0 flex-1 app-text-container" style={{ flexBasis: '12rem' }}>
            {eyebrow && (
              <div className="app-kpi-card__eyebrow mb-1 app-readable">{eyebrow}</div>
            )}
            {title && (
              <h2 className="app-readable app-settings-section__title text-[15px]">
                {title}
              </h2>
            )}
            {description && (
              <p className="app-readable text-[12.5px] mt-1 leading-relaxed" style={{ color: 'var(--text-muted)' }}>
                {description}
              </p>
            )}
          </div>
          {action && <div className="shrink-0 max-w-full">{action}</div>}
        </header>
      )}
      <div className="min-w-0 max-w-full overflow-hidden">{children}</div>
    </section>
  );
}
